const apiUrl = 'https://parser.examplewww.com/'

// const apiUrl = 'http://localhost:8000/'

export default apiUrl
